import photo1 from './photo1.jpg'
import photo2 from './photo2.jpg'
import thumb1 from './thumb1.jpg'
import image1 from './image1.jpg'
import thumb2 from './thumb2.jpg'
import image2 from './image2.jpg'
import thumb3 from './thumb3.jpg'
import image3 from './image3.jpg'
import restaurant from './restaurant.jpg'
import restaurant2 from './restaurant2.jpg'

export { photo1, photo2, thumb1, image1, thumb2, image2, thumb3, image3, restaurant, restaurant2 }



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/Restaurant/images/index.js